"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Rewards API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GiveawayStatisticsToJSON = exports.GiveawayStatisticsFromJSONTyped = exports.GiveawayStatisticsFromJSON = exports.instanceOfGiveawayStatistics = void 0;
/**
 * Check if a given object implements the GiveawayStatistics interface.
 */
function instanceOfGiveawayStatistics(value) {
    var isInstance = true;
    isInstance = isInstance && "initTwitchFollowerCount" in value;
    isInstance = isInstance && "initYouTubeFollowerCount" in value;
    isInstance = isInstance && "initTikTokFollowerCount" in value;
    isInstance = isInstance && "finalTwitchFollowerCount" in value;
    isInstance = isInstance && "finalYouTubeFollowerCount" in value;
    isInstance = isInstance && "finalTikTokFollowerCount" in value;
    return isInstance;
}
exports.instanceOfGiveawayStatistics = instanceOfGiveawayStatistics;
function GiveawayStatisticsFromJSON(json) {
    return GiveawayStatisticsFromJSONTyped(json, false);
}
exports.GiveawayStatisticsFromJSON = GiveawayStatisticsFromJSON;
function GiveawayStatisticsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'initTwitchFollowerCount': json['initTwitchFollowerCount'],
        'initYouTubeFollowerCount': json['initYouTubeFollowerCount'],
        'initTikTokFollowerCount': json['initTikTokFollowerCount'],
        'finalTwitchFollowerCount': json['finalTwitchFollowerCount'],
        'finalYouTubeFollowerCount': json['finalYouTubeFollowerCount'],
        'finalTikTokFollowerCount': json['finalTikTokFollowerCount'],
    };
}
exports.GiveawayStatisticsFromJSONTyped = GiveawayStatisticsFromJSONTyped;
function GiveawayStatisticsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'initTwitchFollowerCount': value.initTwitchFollowerCount,
        'initYouTubeFollowerCount': value.initYouTubeFollowerCount,
        'initTikTokFollowerCount': value.initTikTokFollowerCount,
        'finalTwitchFollowerCount': value.finalTwitchFollowerCount,
        'finalYouTubeFollowerCount': value.finalYouTubeFollowerCount,
        'finalTikTokFollowerCount': value.finalTikTokFollowerCount,
    };
}
exports.GiveawayStatisticsToJSON = GiveawayStatisticsToJSON;
